import { Card, CardBody, CardHeader, Text } from '@change/ds-core-ui';

import { stripHtmlTags } from '@change-corgi/core/html';
import { useGetStaticAssetUrl } from '@change-corgi/core-react/assets';

import type { PetitionShareSlideUpHeaderProps } from '../types';

export const PetitionShareSlidePetitionCard: React.FC<PetitionShareSlideUpHeaderProps> = ({ petition }) => {
	const getStaticAssetUrl = useGetStaticAssetUrl();
	return (
		<div className="text-typography-strong">
			<Card orientation="horizontal" reverse className="grid-cols-[5fr_7fr]">
				<CardHeader variant="media">
					<img
						alt="petition"
						className="group-orientation-vertical/Card:h-40 group-orientation-horizontal/Card:w-40 h-full max-w-full object-cover"
						src={petition.photo ?? getStaticAssetUrl('/images/default-petition-darker.gif')}
					/>
				</CardHeader>

				<CardBody className="min-w-0 py-4">
					<Text as="p" size="medium" fontWeight="bold" className="line-clamp-1 max-h-12 text-ellipsis">
						{petition.ask}
					</Text>

					<Text as="p" size="small" className="text-typography-weak line-clamp-1 max-h-6 text-ellipsis">
						{stripHtmlTags(petition.description)}
					</Text>
				</CardBody>
			</Card>
		</div>
	);
};
